import { ThemeProvider } from "styled-components";

import { Dialogs } from "@sso/components/Dialogs";
import { Snanckbar } from "@sso/components/Snackbar";
import { Routes } from "@sso/routes";
import { lightTheme } from "@sso/theme";
import { GlobalStyles } from "@sso/theme/GlobalStyles";

export const App = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <GlobalStyles />
      <Routes />
      <Snanckbar />
      <Dialogs />
    </ThemeProvider>
  );
};
